<template>
  <div>
    <headerType1 />
    <slot />
    <footer>
      <div class="container">
        <div
          class="row"
          data-aos="fade"
          data-aos-offset="50"
          data-aos-duration="800"
          data-aos-anchor-placement="top-bottom"
        >
          <div class="col-12 footer-link">
            <ul>
              <li>
                <a href="">{{ $t('footer.about') }}</a>
              </li>
              <li>
                <a href="">{{ $t('footer.support') }}</a>
              </li>
              <li>
                <a href="">{{ $t('footer.contact') }}</a>
              </li>
              <li>
                <a href="">{{ $t('footer.map') }}</a>
              </li>
            </ul>
            <div class="icon-btn">
              <img src="@/assets/img/frame02.svg" alt="Pocket Poker Logo" />
              <select :value="locale" class="language-select-footer" @change="handleLanguageChange">
                <option v-for="option in LOCALE_OPTIONS" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 footer-content">
            <div class="row">
              <div class="flex-wrap">
                <div class="col-3 col-sm-12 info-block">
                  <a href="/" class="footer-logo-link"
                    ><img src="@/assets/img/footerLogo.png" alt="Pocket Poker Logo" width="150"
                  /></a>
                  <p>{{ $t('footer.footerText1') }}</p>
                </div>
                <div class="col-3 col-sm-12 info-block">
                  <p class="yellow-text">{{ $t('footer.responsibility') }}</p>
                  <p>{{ $t('footer.footerText2') }}</p>
                  <ul>
                    <li>
                      <a href="" class="yellow-text">{{ $t('footer.download') }}</a>
                    </li>
                    <li>
                      <NuxtLink to="/privacy" class="yellow-text">{{ $t('footer.privacy') }}</NuxtLink>
                    </li>
                    <li>
                      <a href="" class="yellow-text">{{ $t('footer.cookie') }}</a>
                    </li>
                    <li>
                      <NuxtLink to="/rule" class="yellow-text">{{ $t('footer.law') }}</NuxtLink>
                    </li>
                  </ul>
                </div>
                <div class="col-3 col-sm-12 info-block">
                  <img src="@/assets/img/footerImg01.png" alt="Pocket Poker Logo" />
                  <img src="@/assets/img/footerImg02.png" alt="Pocket Poker Logo" />
                  <img src="@/assets/img/footerImg03.png" alt="Pocket Poker Logo" />
                </div>
                <div class="col-3 col-sm-12 info-block media-block">
                  <a href="" aria-label="Facebook"><img src="@/assets/img/footerFb.png" alt="" /></a>
                  <a href="" aria-label="Instagram"><img src="@/assets/img/footerIg.png" alt="" /></a>
                  <a href="" aria-label="X"><img src="@/assets/img/footerX.png" alt="" /></a>
                  <a href="" aria-label="Discord"><img src="@/assets/img/footerDiscord.png" alt="" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <Transition name="fade">
      <div v-show="showGoTop" class="go-top" @click="scrollToTop">
        <img src="@/assets/img/top.png" />
      </div>
    </Transition>
    <Transition name="fade">
      <div v-show="showGoTop" class="side-icon-wrapper">
        <img src="@/assets/img/side-icon01.png" alt="" class="side-icon" />
        <span>{{ $t('footer.service') }}</span>
      </div>
    </Transition>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { getSavedLocale, isSupportedLocale, LOCALE_OPTIONS, saveLocale } from '@i18n';

const { setLocale, locale } = useI18n();
const showGoTop = ref(false);

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const handleScroll = () => {
  showGoTop.value = window.scrollY > 300;
};

const handleLanguageChange = (event: Event) => {
  const newLocale = (event.target as HTMLSelectElement).value;
  if (!isSupportedLocale(newLocale)) return;

  console.log('選擇的語言:', newLocale);
  setLocale(newLocale);
  saveLocale(newLocale); // 儲存語系到 localStorage
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
  const savedLocale = getSavedLocale();
  const targetLocale = isSupportedLocale(savedLocale) ? savedLocale : 'tw';
  if (targetLocale !== locale.value) {
    setLocale(targetLocale);
  }
  saveLocale(targetLocale); // 同時寫入 localStorage
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
<style lang="scss">
@use '@/assets/css/main.scss' as *;

footer {
  background: $color-bg-dark;
  padding: 30px;
  font-size: 13px;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 30px 0;
  }
  .footer-link {
    color: $color-primary;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $color-white;
    padding-bottom: 15px;
    @media screen and (max-width: $breakpoint-mini) {
      flex-direction: column;
      align-items: flex-start;
    }
    ul {
      display: flex;
      li {
        display: flex;
        align-items: center;

        a {
          position: relative;
          display: flex;
          align-items: center;
          height: 100%;
          transition: color 0.3s ease-in-out;

          &:hover,
          &:focus-visible {
            color: $color-gold;
          }

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -16px;
            width: 100%;
            height: 1px;
            background-color: $color-gold;
            z-index: 1;
            transform: scaleX(0);
            transform-origin: left center;
            transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
          }

          &:hover::after,
          &:focus-visible::after {
            transform: scaleX(1);
          }
        }
      }
      li + li {
        margin-left: 50px;
        @media screen and (max-width: $breakpoint-mobile) {
          margin-left: 20px;
        }
        @media screen and (max-width: $breakpoint-smaller) {
          margin-left: 12px;
        }
      }
    }
    .icon-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: $breakpoint-mini) {
        margin-top: 15px;
      }
      select {
        color: $color-white;
      }

      img {
        width: 26px;
        height: 26px;
      }
    }
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    .info-block {
      line-height: 22px;
      color: $color-white;
      min-height: 110px;
      display: flex;
      align-items: flex-end;
      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      &:nth-child(1),
      &:nth-child(2) {
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-end;
      }
      &:nth-child(3),
      &:nth-child(4) {
        a,
        img {
          display: block;
          + a,
          + img {
            margin-left: 20px;
          }
        }
      }
    }
    a {
      transition: color 0.3s ease-in-out;
      position: relative;

      &:hover,
      &.active {
        color: $color-gold;
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -6px;
        width: 100%;
        height: 2px;
        background-color: $color-gold;
        transform: scaleX(0);
        transform-origin: left center;
        transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
      }

      &.active::after,
      &:hover::after,
      &:focus-visible::after {
        transform: scaleX(1);
      }
    }

    .media-block {
      a {
        img {
          transition: filter 0.3s ease-in-out;
        }

        &:hover img,
        &:focus-visible img {
          filter: brightness(2.35);
        }
      }
    }

    .footer-logo-link {
      &:hover,
      &:focus-visible {
        color: inherit;
      }

      &::after {
        display: none;
      }
    }
  }
}
.go-top {
  z-index: 999;
  border-radius: 4px;
  border: 1px solid $color-primary;
  padding: 10px;
  color: $color-white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 120px;
  right: 20px;
  font-size: 15px;
  background: $color-bg-dark;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* Hover 互動特效 */
  &:hover {
    transform: translateY(-5px) scale(1.02);
    // background: linear-gradient(135deg, $color-primary 0%, #ffcc33 100%);
    border-color: #ffcc33;
    box-shadow:
      0 10px 25px rgba(255, 193, 7, 0.4),
      0 0 20px rgba(255, 193, 7, 0.3);
    // color: $color-bg-dark;
    // font-weight: bold;

    img {
      // transform: translateY(-3px);
      // animation: bounce 0.6s ease-in-out infinite;
    }
  }

  /* 點擊時的效果 */
  &:active {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 5px 15px rgba(255, 193, 7, 0.3);
  }

  /* 箭頭彈跳動畫 */
  @keyframes bounce {
    0%,
    100% {
      transform: translateY(-3px);
    }
    50% {
      transform: translateY(-8px);
    }
  }
}

.side-icon-wrapper {
  position: fixed;
  right: 20px;
  bottom: 35px;
  z-index: 9999;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $color-primary;
  font-size: 13px;
  text-align: center;
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    filter 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-5px) scale(1.02);
    filter: drop-shadow(0 4px 8px rgba(255, 193, 7, 0.55)) drop-shadow(0 0 6px rgba(255, 193, 7, 0.6));
  }

  .side-icon {
    width: 40px;
    height: auto;
    margin-bottom: 4px;
  }
}
</style>
